export default "__VITE_ASSET__owFtEgse__"